import React, { useMemo, useState } from 'react'
import {
  Home as IconHome,
  MapPin as IconLocation,
  PlusCircle as IconPlusCircle,
  Plus as IconPlus,
} from 'react-feather'
import { Link } from 'react-router-dom'
import useAxios from 'axios-hooks'
import Breadcrumb from '~/components/Breadcrumb'
import { Col } from '~/components/commons'
import styled from 'styled-components'
import _ from 'lodash'
import { FormattedMessage } from 'react-intl'
import { CustomTable, TableRow, Content } from '~/components/ecto/CustomTable'
import { ButtonCreateMobile } from '~/components/ecto/commons'

function Accounts() {
  const [search, setSearch] = useState('')

  const [{ data, loading, error }] = useAxios('/admin/accounts', {
    useCache: false,
  })

  const accounts = useMemo(() => {
    if (!data || loading || error) {
      return []
    }
    return data
  }, [data, error, loading])

  const countLocations = account => {
    const locations = account?.projects?.reduce((count, project) => {
      return count + (project.locations?.length || 0)
    }, 0)

    return locations
  }

  const accountsList = useMemo(() => {
    const list = !_.isEmpty(search)
      ? accounts.filter(
          el =>
            el.name.toLowerCase().includes(search) ||
            el.id.toLowerCase().includes(search)
        )
      : accounts

    return list.map(account => ({
      ...account,
      totalLocationCount: countLocations(account),
    }))
  }, [search, accounts])

  return (
    <Col>
      <BreadcrumbContainer>
        <Breadcrumb
          className="mb-2"
          paths={[
            {
              render: () => (
                <Link className="d-flex align-items-center" to="/">
                  <IconHome size={20} />
                </Link>
              ),
            },
            { text: 'Accounts' },
          ]}
        />
        <ButtonCreateMobile to="/accounts/new">
          <IconPlusCircle height={14} className="d-none d-md-block" />
          <IconPlus className="d-md-none d-block" />
          <FormattedMessage id="Create account" />
        </ButtonCreateMobile>
      </BreadcrumbContainer>
      <CustomTable
        search
        searchPlaceholder="Search accounts by name or id"
        setSearch={setSearch}
        searchValue={search}
        headers={[
          { name: 'Account', width: '30%', style: { paddingLeft: '30px' } },
          { name: 'ID', width: '30%', center: true },
          { name: 'Projects', width: '20%', center: true },
          { name: 'Locations', center: true },
          { name: 'Users', width: '20%', center: true },
        ]}
      >
        {accountsList?.map(account => (
          <TableRow key={account.id}>
            <Content text="big">{account.name}</Content>
            <Content text="success">{account.id}</Content>
            <Content>{account.projects?.length ?? 'No data'}</Content>
            <Content>
              <IconLocation className="mr-1" />
              {account.totalLocationCount}
            </Content>
            <Content>{account.users?.length ?? 'No data'}</Content>
            <Content>
              <Link to={`/accounts/${account.id}`}>
                <FormattedMessage id="View" />
              </Link>
            </Content>
          </TableRow>
        ))}
      </CustomTable>
    </Col>
  )
}

const BreadcrumbContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export default Accounts
